var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.081448 3.56693C0.0271493 3.61417 0 3.67717 0 3.75591C0 3.83465 0.0271493 3.90551 0.081448 3.9685L5.78281 8.90551C5.8371 8.9685 5.9095 9 6 9C6.0905 9 6.1629 8.9685 6.2172 8.90551L11.9186 3.9685C11.9729 3.90551 12 3.83465 12 3.75591C12 3.67717 11.9729 3.61417 11.9186 3.56693L11.3756 3.09449C11.3213 3.0315 11.2489 3 11.1584 3C11.0679 3 10.9864 3.0315 10.914 3.09449L6 7.37008L1.08597 3.09449C1.01357 3.0315 0.932127 3 0.841629 3C0.751131 3 0.678733 3.0315 0.624434 3.09449L0.081448 3.56693Z",
    fill: "#1B358F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.2621139e130287b9cd8a867d5ec65e48.svg";
export { ForwardRef as ReactComponent };